import coach1 from "../assets/coach.jpg";
import coach2 from "../assets/c2.jpeg";

export default function About() {
  return (
      <section id="about" className="py-16 px-6 bg-white text-center">
 {/* About Intro */}
<div className="max-w-6xl mx-auto mt-10 grid grid-cols-1 md:grid-cols-2 gap-8">

  {/* Who We Are */}
  <div className="bg-gray-100 rounded-2xl p-8 shadow-lg hover:shadow-xl transition">
    <h3 className="text-3xl font-bold text-[#D4AF37] mb-4">
      Who We Are
    </h3>

    <p className="text-gray-700 leading-relaxed">
      Hunters Cricket Club & Academy is committed to developing young
      cricketers through professional coaching, disciplined training,
      and competitive match exposure. Our academy focuses on building
      confident players with strong technical, physical, and mental
      skills required to succeed at higher levels of cricket.
    </p>
  </div>

  {/* What We Offer */}
  <div className="bg-gray-100 rounded-2xl p-8 shadow-lg hover:shadow-xl transition">
    <h3 className="text-3xl font-bold text-[#D4AF37] mb-4">
      What We Offer
    </h3>

    <ul className="space-y-3 text-gray-700 text-left">
      <li>🏏 Professional Cricket Coaching</li>
      <li>💪 Fitness & Conditioning Programs</li>
      <li>🎯 Batting, Bowling & Fielding Training</li>
      <li>🏆 Match Practice & Tournament Exposure</li>
      <li>📹 Performance Analysis & Skill Development</li>
      <li>👦 Coaching for All Age Categories for both boys & girls</li>
    </ul>
  </div>

</div>
 
 <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
  
  <div className="bg-gray-100 p-6 rounded-xl shadow hover:shadow-xl transition">
    <h3 className="text-xl font-bold text-[#D4AF37]">Expert Coaching</h3>
    <p className="mt-2 text-gray-600">Certified and experienced coaches.</p>
  </div>

  <div className="bg-gray-100 p-6 rounded-xl shadow hover:shadow-xl transition">
    <h3 className="text-xl font-bold text-[#D4AF37]">Modern Training</h3>
    <p className="mt-2 text-gray-600">Advanced drills and fitness programs.</p>
  </div>

  <div className="bg-gray-100 p-6 rounded-xl shadow hover:shadow-xl transition">
    <h3 className="text-xl font-bold text-[#D4AF37]">Match Exposure</h3>
    <p className="mt-2 text-gray-600">Regular practice and tournaments.</p>
  </div>

</div>
    

      {/* Coaches Cards */}
      <div className="mt-10 flex flex-col md:flex-row gap-8 justify-center items-stretch">
         <div className="bg-white rounded-2xl shadow-lg p-6 text-center flex-1 hover:scale-105 transition">
          <img
            src={coach2}
            alt="Purusothaman"
            className="w-48 h-48 object-cover object-top rounded-full mx-auto shadow-lg border-4 border-[#D4AF37]"
          />
          <h3 className="mt-4 text-2xl font-bold text-[#D4AF37]">
            Senior Head Coach & Mentor
          </h3>
          <p className="font-semibold">Purusothaman K</p>
          <p className="mt-2 text-gray-700">
              35 years of Experienced coach focusing on technique and match awareness
            for all age groups.<br></br>
              Head coach for U-19 & U-23 and men's senior team coach & mentor,state head coach for Cricket Association of Pondicherry(CAP).
            
          </p>
        </div>
        {/* Coach 1 */}
        <div className="bg-white rounded-2xl shadow-lg p-6 text-center flex-1 hover:scale-105 transition">
          <img
            src={coach1}
            alt="Head Coach Vignesh Krishnaraj"
            className="w-48 h-48 object-cover rounded-full mx-auto shadow-lg border-4 border-[#D4AF37]"
          />
          <h3 className="mt-4 text-2xl font-bold text-[#D4AF37]">
            Head Coach
          </h3>
          <p className="font-semibold"> Vignesh Krishnaraj</p>
          <p className="mt-2 text-gray-700">
            ICC Level-A certified cricket coach with 12+ years of experience training TNCA league team and
            Pondichery Premier league .
          </p>
        </div>
        {/* Coach 1 */}
      
      </div>

      {/* Achievements */}
      <div className="mt-10 text-center">
        <h3 className="text-2xl font-semibold mb-4">Our Achievements</h3>
        <ul className="space-y-3 max-w-md mx-auto text-gray-700">
          <li>🏏 Students selected in TNCA matches</li>
          <li>🏆 Players participated in State Level tournaments</li>
          <li>🎯 Professional match exposure and training</li>
          <li>💪 Fitness and skill development programs</li>
        </ul>
      </div>
      {/* Latest Achievements & News */}
<div className="mt-20">
  
  <h3 className="text-3xl font-bold text-[#D4AF37] mb-10 text-center">
    Latest Achievements & News
  </h3>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

    {/* News Card 1 */}
    <div className="bg-gray-100 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition hover:-translate-y-2">
      
      <img
        src="/tn.jpeg"
        alt="TNCA Selection"
        className="w-full h-52 object-cover"
      />

      <div className="p-6">
        <p className="text-sm text-gray-500">April 2026</p>

        <h4 className="text-xl font-bold text-[#D4AF37] mt-2">
          TNCA League Opportunities 
        </h4>

        <p className="mt-3 text-gray-700">
          Our team player from Rising Star promoted to 
          'Second Division' in TNCA league
        </p>
      </div>
    </div>

    {/* News Card 2 */}
    <div className="bg-gray-100 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition hover:-translate-y-2">
      
      <img
        src="/champ.jpeg"
        alt="Tournament Winners"
        className="w-full h-52 object-cover"
      />

      <div className="p-6">
        <p className="text-sm text-gray-500">2026</p>

        <h4 className="text-xl font-bold text-[#D4AF37] mt-2">
          Tournament Champions
        </h4>

        <p className="mt-3 text-gray-700">
          Hunters Cricket Academy won the inter-academy T20 tournament
          with excellent team performances.
        </p>
      </div>
    </div>

    {/* News Card 3 */}
    <div className="bg-gray-100 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition hover:-translate-y-2">
      
      <img
        src="/summer.jpeg"
        alt="Summer Camp"
        className="w-full h-52 object-cover"
      />

      <div className="p-6">
        <p className="text-sm text-gray-500">April 2026</p>

        <h4 className="text-xl font-bold text-[#D4AF37] mt-2">
          Summer Coaching Camp
        </h4>

        <p className="mt-3 text-gray-700">
          Special summer coaching sessions started for young cricketers
          focusing on fitness and match preparation.
        </p>
      </div>
    </div>

  </div>
</div>
    </section>
  );
}